(function() {
    'use strict';

    angular.module('app').factory('VersionManagerService', VersionManagerService);

    VersionManagerService.$inject = ['$http', '$localStorage', 'DistributionService'];

    function VersionManagerService($http, $localStorage, DistributionService) {
        var versions = [
            {
                version: '5.0.0',
                date: '2020-03-25',
                changelog: {
                    added: [],
                    changed: [],
                    fixed: [],
                    removed: [],
                },
            },
        ];

        return {
            current: current,
            history: history,
            load: load,
        };

        function current() {
            return versions[0].version;
        }

        function history() {
            return versions;
        }

        function load() {
            var json = './../../../version/' + DistributionService.code() + '.json';

            return $http.get(json).then(
                function(data) {
                    versions = data.data.versions;

                    if (current() !== $localStorage.version) {
                        $localStorage.version = current();
                        return true;
                    }

                    return false;
                },
                function() {
                    return false;
                }
            );
        }
    }
})();
